import {
  NgbAlertModule,
  NgbCarouselModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';

import { CalendarModule } from './modules/calendar/calendar.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CommonModule } from '@angular/common';
import { EulaComponent } from './pages/eula/eula.component';
import { FamilyTreeModule } from './modules/family-tree/family-tree.module';
import { FormsModule } from '@angular/forms';
import { FrontEndFormComponent } from './components/common/form/front-end-form.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LayoutModule } from './modules/layout/layout.module';
import { MigFormModule } from './modules/mig-form/mig-form.module';
import { MinervaPageComponent } from './pages/minerva-page/minerva-page.component';
import { MslaPageComponent } from './pages/msla-page/msla-page.component';
import { MyPageModule } from './modules/my-page/my-page.module';
import { MyStoriesModule } from './modules/my-stories/my-stories.module';
import { NgModule } from '@angular/core';
import { OurStoryPageComponent } from './pages/our-story-page/our-story-page.component';
import { PolicyPageComponent } from './pages/policy-page/policy-page.component';
import { QualityOfLifePageComponent } from './pages/quality-of-life-page/quality-of-life-page.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RegistrationComponent } from './components/registration/registration.component';
import { ResidentEngagementPageComponent } from './pages/resident-engagement-page/resident-engagement-page.component';
import { ResidentExperiencesPageComponent } from './pages/resident-experiences-page/resident-experiences-page.component';
import { ResidentInsightsPageComponent } from './pages/resident-insights-page/resident-insights-page.component';
import { SalesSupportToolPageComponent } from './pages/sales-support-tool-page/sales-support-tool-page.component';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { SurveyFeedbackPlatformPageComponent } from './pages/survey-feedback-platform-page/survey-feedback-platform-page.component';
import { UponRegistrationModule } from './modules/upon-registration/upon-registration.module';
import { VideoModalComponent } from './pages/home-page/video-modal/video-modal.component';
import { WebSiteRoutingModule } from './web-site-routing.module';
import { WishThereModule } from './modules/wish-there/wish-there.module';

@NgModule({
  declarations: [
    HomePageComponent,
    RegistrationComponent,
    ResidentEngagementPageComponent,
    MinervaPageComponent,
    PolicyPageComponent,
    FrontEndFormComponent,
    MslaPageComponent,
    OurStoryPageComponent,
    ResidentInsightsPageComponent,
    ResidentExperiencesPageComponent,
    QualityOfLifePageComponent,
    SalesSupportToolPageComponent,
    SurveyFeedbackPlatformPageComponent,
    VideoModalComponent,
    EulaComponent,
  ],
  imports: [
    CommonModule,
    WebSiteRoutingModule,
    NgbCarouselModule,
    LayoutModule,
    FormsModule,
    ReactiveFormsModule,
    NgbAlertModule,
    NgbTooltipModule,
    NgbNavModule,
    NgbTooltipModule,
    FamilyTreeModule,
    MyPageModule,
    MyStoriesModule,
    UponRegistrationModule,
    WishThereModule,
    MigFormModule,
    ScrollToModule.forRoot(),
    CarouselModule,
  ],
})
export class WebSiteModule {}
